import { render, staticRenderFns } from "./user-profile-personal-information-tab.vue?vue&type=template&id=33725904&"
import script from "./user-profile-personal-information-tab.vue?vue&type=script&lang=ts&"
export * from "./user-profile-personal-information-tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
